import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';

const SimpleCarousel = ({ children, interval = 6000 }) => {
  const slides = useMemo(() => React.Children.toArray(children), [children]);
  const [active, setActive] = useState(0);

  useEffect(() => {
    if (slides.length <= 1) return undefined;
    const timer = window.setInterval(() => {
      setActive(current => (current + 1) % slides.length);
    }, interval);
    return () => window.clearInterval(timer);
  }, [slides.length, interval]);

  if (slides.length === 0) return null;

  return (
    <Box sx={{ width: '100%', overflow: 'hidden' }}>
      {slides[active]}
    </Box>
  );
};

export default SimpleCarousel;
